import Header from "./components/Header";
import Hero from "./components/Hero";
import EmpathySection from "./components/EmpathySection";
import IdealExperienceSection from "./components/IdealExperienceSection";
import ExpertiseSection from "./components/ExpertiseSection";
import TroubleCardsSection from "./components/TroubleCardsSection";
import ConsultationSection from "./components/ConsultationSection";
import BeforeAfterSection from "./components/BeforeAfterSection";
import ContentSection from "./components/ContentSection";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="w-full overflow-x-hidden">
      <Header />
      <main>
        <Hero />
        <EmpathySection />
        <IdealExperienceSection />
        <ExpertiseSection />
        <TroubleCardsSection />
        <ConsultationSection />
        <BeforeAfterSection />
        <ContentSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}